import { apiFetch } from './client';

export interface AgentInfo {
  id: string;
  name: string;
  email: string;
  role: string;
  tenantId: string;
  mustChangePassword: boolean;
  departments: { id: string; name: string }[];
}

// Login response: agent info only — the JWT is set by the server as an httpOnly
// cookie and is never returned in the response body. Does NOT include
// tenantId or mustChangePassword — the caller always follows up with getMe()
// for the full picture (see AuthContext.login()).
export interface LoginResponse {
  agent: Omit<AgentInfo, 'tenantId' | 'mustChangePassword' | 'departments'>;
}

/** `remember`: "keep me signed in on this device" — a 30-day session instead of the default one. */
export function login(email: string, password: string, remember = false): Promise<LoginResponse> {
  return apiFetch<LoginResponse>('/auth/login', {
    method: 'POST',
    body: JSON.stringify({ email, password, remember }),
  });
}

export function logout(): Promise<{ ok: boolean }> {
  return apiFetch<{ ok: boolean }>('/auth/logout', { method: 'POST' });
}

export function getMe(): Promise<AgentInfo> {
  return apiFetch<AgentInfo>('/auth/me');
}

export function changePassword(currentPassword: string, newPassword: string): Promise<{ ok: boolean }> {
  return apiFetch<{ ok: boolean }>('/auth/change-password', {
    method: 'POST',
    body: JSON.stringify({ currentPassword, newPassword }),
  });
}
